<template>
  <div class="container">
    <PageHeader style="margin:10px 0 0 0;" />
    <div class="content page_main_content" style="background:#fff; min-height: 500px; text-align:center; padding: 120px 0;">
      <a-icon type="info-circle" style="font-size: 48px; color: #1890ff;" />
      <h2 style="margin: 24px 0 16px; color: rgba(0,0,0,0.85);">版式未支持</h2>
      <p style="font-size: 16px; color: rgba(0,0,0,0.45); margin-bottom: 24px;">
        请前往新版天眼查看
      </p>
      <a :href="newUrl" target="_blank">
        <a-button type="primary" size="large">
          切换天眼AI
          <a-icon type="arrow-right" />
        </a-button>
      </a>
      <p style="margin-top: 16px; color: rgba(0,0,0,0.35); font-size: 13px;">
        {{ newUrl }}
      </p>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/game/pageheader.vue'

export default {
  components: {
    PageHeader,
  },
  props: {
    parent: { type: String, default: '' },
    name: { type: String, default: '' },
  },
  computed: {
    projCode() {
      return this.$store.state.game.code || ''
    },
    pageId() {
      return this.$route.query.id || ''
    },
    newUrl() {
      if (!this.projCode || !this.pageId) {
        return '#'
      }
      return `https://ux.leihuo.netease.com/dc3/${this.projCode}/subjects/${this.projCode}.${this.pageId}`
    },
  },
}
</script>
